export default __webpack_public_path__ + "static/bg-ai-as-a-service-24271b1b365621897e79e079848755e8.webp";